export default __webpack_public_path__ + "static/media/Solace-Quantstamp-Report.44617837.pdf";